import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { PermissionUser } from "@/types/globalTypes";
import axios, { AxiosError } from "axios";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { useState } from "react";
interface bodyProps {
    userData: PermissionUser
}
export default function PermissionsTableBody({ userData }: bodyProps) {
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(false);
    const locale = i18n.language;
    const baseUrl = import.meta.env.VITE_BASE_URL;
    const token = useSelector((state: { auth: { token: string } }) => state.auth.token);


    async function handleResendCode(id: string) {
        const toastId = toast.loading(t("orders.loading"));
        setLoading(true);

        try {
            const response = await axios.post(
                `${baseUrl}/api/dashboard/users/all/${id}/resend`,
                {}, // empty body
                {
                    headers: {
                        Authorization: token,
                    },
                }
            );

            if (response.data.success) {
                toast.success(t("permissions.inviteSent"));
            } else {
                console.error("Failed to resend code:", response.data.error);
            }

        } catch (error) {
            const axiosError = error as AxiosError<{ error: string }>;
            console.error("Error resending code:", axiosError);
            toast.error(axiosError.response?.data?.error || "An unexpected error occurred");
        } finally {
            toast.dismiss(toastId);
            setLoading(false);
        }
    }

    return (
        <>


            <tr className="border-b text-start bg-white">
                <td className="px-6 py-4 text-sidebar font-semibold  underline">
                    <Link to={`employee-info/${userData._id}`}> {userData.username !== "" ? userData.username : t("permissions.noName")}</Link>
                </td>
                <td className="px-6 py-4">
                    {userData.email !== "" ? userData.email : t("permissions.noEmail")}
                </td>
                <td className="px-6 py-4">
                    {userData.phone !== null ? userData.phone : t("permissions.noPhone")}
                </td>
                <td className="px-6 py-4">
                    {locale === "ar" ? userData.roleNameAR : userData.roleNameEN}
                </td>
                <td className="px-6 py-4">
                    {locale === "ar" ? userData.branchNameAR : userData.branchNameEN}
                    {userData.role === "owner" || userData.role === "superadmin" ? <span className="text-green-600 text-[13px] font-semibold">{t("permissions.noBranch")}</span> : ""}
                </td>
                <td className="px-6 py-4">
                    <span className={`${userData.status === "active" ? "text-green-700 bg-green-300" : "bg-yellow-200 text-yellow-900"} px-3 py-1 text-[10px] rounded-full`}>
                        {userData.status === "active" ? t("permissions.active") : t("permissions.pending")}
                    </span>
                </td>
                <td className="px-6 py-4">
                    {userData.status === "pending" ? <button disabled={loading} onClick={() => handleResendCode(userData._id)} className="my-btn w-fit text-[12px] px-2">
                        {t("permissions.resendCode")}
                    </button> : ""}
                </td>

            </tr>



        </>
    )
}
